/**
 * @generated SignedSource<<055e88391f5949e68ed272f92d4239b9>>
 * @relayHash 2f859fbb78d9053f044aa6da73b2ab48
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/551.0.0-2026-03-10T20:04:54.288Z/dealerQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type dealerQuery$variables = {
  customBannerText?: string | null;
  dotComHost: string;
  hasSellerPk: boolean;
  hyperwalletLink: string;
  sellerPk?: string | null;
  userId?: string | null;
};
export type dealerQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerNav_viewer">;
  };
};
export type dealerQuery = {
  response: dealerQuery$data;
  variables: dealerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "customBannerText"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dotComHost"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSellerPk"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hyperwalletLink"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "sellerPk"
},
v5 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v6 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "href",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interactionType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideSideNavTitle",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataTn",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newWindow",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "dealerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SellerNav_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "dealerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "presenceFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "presence"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"presence\")"
          },
          {
            "alias": "onSessionSellerChargesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "onSessionSellerBillingStatementCharges"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"onSessionSellerBillingStatementCharges\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "customBannerText",
                "variableName": "customBannerText"
              },
              {
                "kind": "Variable",
                "name": "dotComHost",
                "variableName": "dotComHost"
              },
              {
                "kind": "Variable",
                "name": "hyperwalletLink",
                "variableName": "hyperwalletLink"
              },
              {
                "kind": "Variable",
                "name": "sellerPk",
                "variableName": "sellerPk"
              },
              (v6/*: any*/)
            ],
            "concreteType": "DealerNavBar",
            "kind": "LinkedField",
            "name": "dealerNavBar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NavBarButton",
                "kind": "LinkedField",
                "name": "buttons",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NavBarLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "navItems",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNavBarElement"
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v9/*: any*/),
                      (v15/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NavBarListItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "NavBarElement",
                                "abstractKey": "__isNavBarElement"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "NavBarList",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "condition": "hasSellerPk",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "sellerId",
                    "variableName": "sellerPk"
                  }
                ],
                "concreteType": "Seller",
                "kind": "LinkedField",
                "name": "seller",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RepData",
                    "kind": "LinkedField",
                    "name": "sellerRep",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vertical",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v6/*: any*/)
                    ],
                    "concreteType": "CreateListingOption",
                    "kind": "LinkedField",
                    "name": "createListingOptions",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingProfile",
                    "kind": "LinkedField",
                    "name": "billingProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "runningBalance",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VatConfiguration",
                    "kind": "LinkedField",
                    "name": "vatConfiguration",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceBookName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PresenceResults",
                    "kind": "LinkedField",
                    "name": "presence",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recentOnlineDate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SellerPreferences",
                    "kind": "LinkedField",
                    "name": "sellerPreferences",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showOnlineStatus",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SellerProfile",
                    "kind": "LinkedField",
                    "name": "sellerProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "company",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/551.0.0-2026-03-10T20:04:54.288Z/dealerQuery",
    "metadata": {},
    "name": "dealerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bd3942bcb1ad80919d42865023d68644";

export default node;
